import {removeTypeNameFromQuery} from '~/utils';

export const MEDIA_FRAGMENT = `#graphql
  fragment Media on Media {
    mediaContentType
    alt
    __typename
    previewImage {
      url
      __typename
    }
    ... on MediaImage {
      id
      __typename
      image {
        url
        width
        height
      }
    }
    ... on Video {
      id
      __typename
      sources {
        mimeType
        url
      }
    }
    ... on Model3d {
      id
      __typename
      sources {
        mimeType
        url
        __typename
      }
    }
    ... on ExternalVideo {
      id
      embedUrl
      host
      __typename
    }
  }
`;

export const MULTI_OBJECT_CONTENT_FRAGEMENT = `
fragment MultiMetaObjectContentFragment on Metaobject {
  id
  type
  handle
  __typename
  fields {
    __typename
    type
    value
    key
    
    reference {
      ... on Metaobject {
        __typename
        id
        handle
        fields {
          __typename
          value
          type
          key
        }
        type
      }
      ...Media
    }
    references(first: 100) {
      nodes {
        __typename
        ... on Metaobject {
          __typename
        id
        fields {
          __typename
          value
          type
          key
        }
        type
      }
        ...Media
      }
    }
  }
}


`;
export const metaObjectContentFragment = `#graphql
${MEDIA_FRAGMENT}
${MULTI_OBJECT_CONTENT_FRAGEMENT}
fragment MetaObjectContentFragment on Metaobject {
  id
  type
  handle
  __typename
  fields {
    __typename
    type
    value
    key
    reference {
      ... on Metaobject {
        __typename
        id
        fields {
          value
          type
          key
          __typename
          references(first: 100) {
            nodes {
              __typename
              ...MultiMetaObjectContentFragment
              ...Media
            }
          }
        }
        type
      }
      ...Media
    }
    references(first: 100) {
      nodes {
        ...MultiMetaObjectContentFragment
        ...Media
      }
    }
  }
}`;
const PAGE_FRAGEMENT_QUERY = `
${metaObjectContentFragment}
query PageDetails($language: LanguageCode, $handle: String!) @inContext(language: $language) {
  page(handle: $handle) {
    __typename
    id
    title
    body
    sections: metafields(identifiers: {namespace: "page", key: "sections"}) {
      key
      value
      __typename
      references(first: 100) {
        nodes {
          __typename
          ...Media
          ...MetaObjectContentFragment
        }
      }
    }
    hero_section: metafields(identifiers: {namespace: "page", key: "hero_section"}) {
      key
      value
      __typename
      reference {
        __typename
        ...Media
        ...MetaObjectContentFragment
      }
    }
    page_banner: metafields(identifiers: {namespace: "page", key: "page_header_banner"}) {
      key
      value
      __typename
      reference {
        __typename
        ...Media
        ...MetaObjectContentFragment
      }
    }
    image_content: metafields(
      identifiers: {namespace: "page", key: "image_contents"}
    ) {
      key
      value
      __typename
      references(first: 100) {
        nodes {
          __typename
          ...Media
          ...MetaObjectContentFragment
        }
      }
    }
    seo {
      __typename
      description
      title
    }
  }
}
`;
export const PRODUCT_CARD_FRAGMENT = `#graphql
  fragment ProductCard on Product {
    id
    title
    publishedAt
    handle
    mainMedia: metafields(identifiers: {key: "mainmedia", namespace: "custom"}) {
      key
      value
    }
    additionalMedia: metafields(identifiers: {key: "additionalmedia", namespace: "custom"}) {
      key
      value
    } 
    __typename
    variants(first: 1) {
      nodes {
        id
        image {
          url
          altText
          width
          height
        }
        price {
          amount
          currencyCode
        }
        compareAtPrice {
          amount
          currencyCode
        }
        selectedOptions {
          name
          value
        }
        product {
          handle
          title
        }
      }
    }
  }
`;

const METAOBJECT_QUERY = `
#graphql
${metaObjectContentFragment}
query MetaObjectContent($metaobjectHandleInput: MetaobjectHandleInput, $country: CountryCode, $language: LanguageCode) @inContext(country: $country, language: $language) {
  metaobject(handle: $metaobjectHandleInput) {
    ...MetaObjectContentFragment
  }
}
`;

const GET_METAOBJECT_QUERY = `
#graphql
${metaObjectContentFragment}
query GetMetaObject($id: ID) {
  metaobject(id: $id) {
    ...MetaObjectContentFragment
  }
}`;

export const getMetaObjectQuery = () => {
  return removeTypeNameFromQuery(GET_METAOBJECT_QUERY);
};

export const metaObjectQuery = () => {
  return removeTypeNameFromQuery(METAOBJECT_QUERY);
};

export const pageQuery = () => {
  const q = removeTypeNameFromQuery(PAGE_FRAGEMENT_QUERY);
  return q;
};

const COLLECTION_CONTENT = `
${PRODUCT_CARD_FRAGMENT}
fragment CollectionContent on Collection {
  
  id
  handle
  title
  descriptionHtml
  products(first: 100) {
    nodes {
      ...ProductCard
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}`;

export const COLLECTION_CONTENT_QUERY = `
${COLLECTION_CONTENT}
query collectionContent($id: ID, $country: CountryCode, $language: LanguageCode) @inContext(country: $country, language: $language) {
   collection(id: $id) {
    ...CollectionContent
  }
 
}`;
